<template>
	<div id="app" v-wechat-title="this.$route.meta.title">
		<keep-alive>
			<router-view v-if='$route.meta.keepAlive'/>
		</keep-alive>
		<router-view v-if='!$route.meta.keepAlive'/>
		
	</div>
</template>

<script>
    
import wx from 'weixin-js-sdk';
import { Toast } from 'vant';
import Qs from 'qs';

export default {
  name: 'app',
	components: {
		[Toast.name]: Toast
		},
	data() {
		return {
			query:Qs.parse(location.search.substring(1)),
            currentRoute:'',
            token:'',
		}
	},
	created(){
		this.initData();
	},
    mounted(){
        
    },
	methods: {
		initData(){
            this.getUser();
			
		},
        ontoken(data){
        	if(this.isUA()=="ios"){
        		data&&data.type=='1'?this.login(data.token):data&&data.type=='0'?this.logout():'';
        	}else if(this.isUA()=="android"){
        		data&&data.type=='1'?this.login(data.token):data&&data.type=='0'?this.logout():'';
        	}
        },
        istoken(obj){
            // console.log(obj)
        	if(this.isWeiXin()){
        		let _that=this;
        		wx.miniProgram.getEnv((res)=> {
                    // console.log(res)
        			if (res.miniprogram) {//在小程序中
                        _that.login();
        			}else{
        				_that.oncode()
        			}
        		})
        	}
        },
        oncode(obj){
            let query=Qs.parse(location.search.substring(1));
            // this.$store.dispatch('set_iscode',2);
            // if(obj.name!="login"){
                if(!query.code){
                	this.axios.post(this.ajaxUrl('bdp',"d=wxapi&c=mp_auth&m=get_authurl"), Qs.stringify({
                		'redirecturi':window.location.href
                	})).then((res) => {
                		if(res.data.status_code == 200){
                			if(res.data.data.gotoflag==true){
                				window.location.href=res.data.data.gotourl;
                			}
                		}
                	})
                }else{
                	this.axios.post(this.ajaxUrl('bdp',"d=wxapi&c=mp_auth&m=call_back"), Qs.stringify({
                		'code':query.code
                	})).then((res) => {
                		window.location.href=window.location.href.split('?')[0] +'?dataFrom='+this.$store.state.qureydata.dataFrom+'#/' + this.currentRoute.name+'?'+this.$getRouter(this.currentRoute.query);
                	})
                }
                
            // }
            
        },
        login(data){
        	if(this.token){
        		this.axios.post(this.ajaxUrl("bdp","d=wxapi&c=mp_auth&m=login"), Qs.stringify({
        			"token":this.token,
        		})).then((res) => {
        			console.log(res)
        			if (res.data.status_code == 200) {
        				this.$store.dispatch('set_userdata',res.data.data);
        				this.$store.dispatch('set_loginstatus',1);
        			} else{
        				// Toast(res.data.message);
        			}
        		})
        	}
        },
        logout(data){
        	this.axios.post(this.ajaxUrl("bdp","d=wxapi&c=mp_auth&m=logout"), Qs.stringify({
        	})).then((res) => {
        		console.log(res)
        		if (res.data.status_code == 200) {
        			this.$store.dispatch('set_userdata', '')
        			this.$store.dispatch('set_loginstatus',2);
        			// Toast(res.data.message);
        		} else{
        			// Toast(res.data.message);
        		}
        	})
        },
        getConfig(){
            this.axios.get(this.ajaxUrl("bdp","d=wxapi&c=open_config&m=get_config"), {
            }).then((res) => {
                console.log(res)
                if(res.data.status_code === 200){
                    var data=res.data.data;
                    this.$store.dispatch('set_configdata', data);
                    // this.$share(data.businessname,this.$imgurl('share','tgjmbp_share.png'),data.businessname,sharelink)
                }
            })  
        },
        getSignature(){
             this.axios.post(this.ajaxUrl('bdp',"d=wxapi&c=mp_auth&m=get_signature"), Qs.stringify({
             	"url": window.location.href.split('#')[0],
             }) ).then((res) => {
             	var result = res.data.data;
             	wx.config({
             		debug: true,
             		appId: result.appid, // 必填，公众号的唯一标识
             		timestamp: result.timestamp, // 必填，生成签名的时间戳
             		nonceStr: result.noncestr, // 必填，生成签名的随机串
             		signature: result.signature,// 必填，签名
             		jsApiList: ['onMenuShareTimeline', 'onMenuShareAppMessage','chooseImage','getLocalImgData','uploadImage','getLocation'] // 必填，需要使用的JS接口列表
             	})
                this.getshare()
                this.getConfig();
             }) 
             
             
         },
		 getUser(){
			 this.axios.get(this.ajaxUrl("bdp","d=wxapi&c=user&m=profile"), {
			 }).then((res) => {
			 	console.log(res)
			 	if (res.data.status_code === 200) {
                    let userdata=res.data.data.userinfo;
			 		this.$store.dispatch('set_userdata', userdata);
			 		this.$store.dispatch('set_loginstatus',1);
                    this.$store.dispatch('set_maincatids',userdata.maincatids);
                    
			 	}else if (res.data.status_code === 201) {
					this.$store.dispatch('set_userdata', '');
			 		this.$store.dispatch('set_loginstatus',2);
                    this.$store.dispatch('set_maincatids','');
			 	}else{
					this.$store.dispatch('set_loginstatus','')
                    
			 	}
                this.getSignature();
			 })
		 },
         getshare(){
            let sharelink='http://www.tgj168.com/web/etp/draft/?dataFrom='+this.$store.state.qureydata.dataFrom+'#/homeIndex?'+this.$getRouter(this.$route.query)+'&tid='+(this.$store.state.userdata?this.$store.state.userdata.usermobile:'');
            if(this.currentRoute.name=='recommendtwo'){
                sharelink='http://www.tgj168.com/web/etp/draft/?dataFrom='+this.$store.state.qureydata.dataFrom+'#/recommendtwo?'+this.$getRouter(this.$route.query)+'&tid='+(this.$store.state.userdata?this.$store.state.userdata.usermobile:'');
            }
            let sharedesc="一键上传票据，万家资金方为您报价";
            let shareimg=this.$imgurl('share','draft_share.png');
            let _this=this;
            console.log(sharelink)
            wx.ready(function () {
                 wx.onMenuShareTimeline({ // “分享到朋友圈”及“分享到QQ空间”
                     title: sharetitle,
                     link: sharelink,
                     imgUrl: shareimg,
                     success: function () {
                            _this.changeScore();
                     },
                 })
                 wx.onMenuShareAppMessage({ // “分享给朋友”及“分享到QQ”
                     title:sharetitle,
                     desc:sharedesc,
                     link: sharelink,
                     imgUrl: shareimg,
                     success: function () {
                            _this.changeScore();
                     },
                 })
            })
         },
         changeScore(){
             this.axios.post('http://www.tgj168.com/mbp/common/index.php?dataType=json&dataFrom=tgjdcbx/mp&d=wxapi&c=se_qas_subject&m=user_share', Qs.stringify({
             })).then((res) => {
             })
         },
		 
	 },
    watch: {
        // '$route.query.token' (val,oldVal) {
        //     console.log(val,oldVal)
        // 	if(val!=oldVal){
        // 		this.istoken()
        // 	}
        // },
        // 'token' (val,oldVal) {
        // 	if(val!=oldVal){
        // 		this.istoken()
        // 	}
        // },
        '$route' () {
            
			let obj = this.$router.currentRoute.meta;
            this.currentRoute=this.$router.currentRoute;
            this.token=this.$router.currentRoute.query.token;
            this.istoken(this.currentRoute);
            this.$store.dispatch('set_sharePopup',false);
            this.$store.dispatch('set_modePopup',false);
            this.$store.dispatch('set_loginshow',false);
            this.$store.dispatch('set_islogin',false);
            if(
            // this.curUrl != '/deviceDetails'&&
            this.curUrl != '/deviceDetails'&&
            this.curUrl != '/deviceDetailsetp'&&
            this.curUrl != '/shopDetails'&&
            this.curUrl != '/logisticsDetails'&&
            this.curUrl !='/forumDetails'&&
            this.curUrl !='/partsDetails'&&
            this.curUrl !='/dynamicDetail'
            ){
                this.getshare()
            }
		}
	},
}
</script>